<template>
  <footer class="relative">
    <div class="w-full max-w-full lg:max-w-screen-lg xl:max-w-screen-2xl mx-auto px-4 py-8">
      <div class="flex flex-col md:flex-row gap-y-4 md:gap-y-0 items-center justify-between text-sm text-purple-gray font-semibold">
        <p class="text-purple-gray/50">
          © 2025 Lingo. All rights reserved.
        </p>

        <div class="flex flex-col md:flex-row gap-y-4 md:gap-y-0 items-center gap-x-24 *:hover:text-lavender">
          <router-link
            v-if="LingoRouteName.HOME"
            to="#"
            :onclick="openInfoModal"
            class="cursor-pointer"
          >
            How it works?
          </router-link>
          <router-link :to="lingoRoutePath[LingoRouteName.FAQ]">
            FAQ
          </router-link>
          <router-link :to="lingoRoutePath[LingoRouteName.TERMS_OF_SERVICE]">
            Terms of Service
          </router-link>
          <router-link :to="lingoRoutePath[LingoRouteName.PRIVACY_POLICY]">
            Privacy Policy
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { LingoRouteName, lingoRoutePath } from '@/router/routes'
import { useLocalStorage } from '@vueuse/core'

const infoModal = useLocalStorage('show-info-modal', false, {
  writeDefaults: false,
})

const openInfoModal = () => {
  infoModal.value = true
}
</script>
